import Form from '../_form';
import Popup from '../../components/popup';

export default class JobReviewForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const reset = this.form.querySelector('.site-button[type="reset"]');

        this.popup = new Popup({
            popup: '.site-popup[data-popup="review-job"]',
            toggle: '#review-job-trigger',
            close: '.site-popup-close[data-popup="review-job"]',
            window: '.site-popup-window[data-popup="review-job"]'
        });

        reset.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            this.popup.close.click();
        });
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const rating = formData.get('rating');
        const review = formData.get('review');

        try {
            await fetch('/wp-json/jobs/v1/review', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ rating, review })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Your review sent!', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    setTimeout(() => window.location.reload(), 3000);
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });

            this.popup.close.click();
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');

            this.popup.close.click();
        }
    }
}
